// src/constants/transactionConstants.js

// Delivery - Deposit
export const DELIVERY_DEPOSIT_REQUEST = "DELIVERY_DEPOSIT_REQUEST";
export const DELIVERY_DEPOSIT_SUCCESS = "DELIVERY_DEPOSIT_SUCCESS";
export const DELIVERY_DEPOSIT_FAIL = "DELIVERY_DEPOSIT_FAIL";

// Delivery - Withdraw
export const DELIVERY_WITHDRAW_REQUEST = "DELIVERY_WITHDRAW_REQUEST";
export const DELIVERY_WITHDRAW_SUCCESS = "DELIVERY_WITHDRAW_SUCCESS";
export const DELIVERY_WITHDRAW_FAIL = "DELIVERY_WITHDRAW_FAIL";

// Admin - Pending Deposits
export const ADMIN_GET_PENDING_DEPOSITS_REQUEST =
  "ADMIN_GET_PENDING_DEPOSITS_REQUEST";
export const ADMIN_GET_PENDING_DEPOSITS_SUCCESS =
  "ADMIN_GET_PENDING_DEPOSITS_SUCCESS";
export const ADMIN_GET_PENDING_DEPOSITS_FAIL =
  "ADMIN_GET_PENDING_DEPOSITS_FAIL";

// Admin - Confirm Deposit
export const ADMIN_CONFIRM_DEPOSIT_SUCCESS = "ADMIN_CONFIRM_DEPOSIT_SUCCESS";

// Admin - Pending Withdrawals
export const ADMIN_GET_PENDING_WITHDRAWALS_REQUEST =
  "ADMIN_GET_PENDING_WITHDRAWALS_REQUEST";
export const ADMIN_GET_PENDING_WITHDRAWALS_SUCCESS =
  "ADMIN_GET_PENDING_WITHDRAWALS_SUCCESS";
export const ADMIN_GET_PENDING_WITHDRAWALS_FAIL =
  "ADMIN_GET_PENDING_WITHDRAWALS_FAIL";

// Admin - Approve/Reject Withdrawal
export const ADMIN_APPROVE_WITHDRAW_SUCCESS = "ADMIN_APPROVE_WITHDRAW_SUCCESS";
export const ADMIN_REJECT_WITHDRAW_SUCCESS = "ADMIN_REJECT_WITHDRAW_SUCCESS";

// Delivery - Get My Transactions
export const DELIVERY_GET_MY_TRANSACTIONS_REQUEST =
  "DELIVERY_GET_MY_TRANSACTIONS_REQUEST";
export const DELIVERY_GET_MY_TRANSACTIONS_SUCCESS =
  "DELIVERY_GET_MY_TRANSACTIONS_SUCCESS";
export const DELIVERY_GET_MY_TRANSACTIONS_FAIL =
  "DELIVERY_GET_MY_TRANSACTIONS_FAIL";
